import styled from "styled-components";

const Wrapper = styled.div`
    height: 100%;
    padding: var(--fits--vertical-padding) var(--fits--horizontal-padding);
    overflow: auto;
    scrollbar-width: ${({scrollbarVisible}) => scrollbarVisible ? 'auto' : 'none'};
}
`

export function OverlayContent({children, scrollbarVisible = true}) {
    return <Wrapper scrollbarVisible={scrollbarVisible}>{children}</Wrapper>
}
